import styled from 'styled-components';

export const EntInfosContainer = styled.div`
    width: 100%;
    font-size: 0.9rem;
    margin-top: 1rem;
`;

export const Container = styled.div`
  padding: 20px;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-top: 15px;
  box-shadow:  2px 7px 18px 2px rgba(0,0,0,0.08);
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  //gap: 8px;
  margin-bottom: 5px;
`;



export const Label = styled.span`
  font-size: 14px;
  color: #8392AB;
  min-width:45px;
    max-width:45px;
`;


export const ChildContainer = styled.div`
  margin-left: 32px;
  margin-top: 10px;
  padding-left: 10px;
  border-left: 3px dashed #CCC;
`;

export const FormInputAgence = styled.input`
  /* flex: 1; */
  border: none;
  outline: none;
  flex: 1;
  /* width: 170px; */
  text-align: right;
  color: #505050;
  font-size: 0.8rem;
  ${({ err, theme }) => !err && "border-bottom: 1px solid #EE5A5A"} ;
  /* border-bottom:1px solid #EE5A5A; */
  &::placeholder {
    color: ${({ theme }) => theme.colors.gray};
    font-style: italic;
  }
`;
